import axios from 'axios';

export interface ImageSettings {
  maxImageSizeKb: number;
  defaultMaxImageSizeKb: number;
  maxImagesPerStory: number;
  enabled: boolean;
}

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

export const settingsService = {
  async getImageSettings(): Promise<ImageSettings> {
    const response = await axios.get(`${API_BASE_URL}/settings/image`);
    return response.data;
  },

  async updateImageSettings(settings: ImageSettings): Promise<ImageSettings> {
    const response = await axios.put(`${API_BASE_URL}/admin/settings/image`, settings);
    return response.data;
  }
};